import { useCallback, useReducer } from 'react';
import { useLocalStorage } from 'react-use';
import { actionTypeOfMedicalHistory } from 'reducer/actionType';

export const LOCAL_STORAGE_MH_KEY = 'populate_medical_history';

export type StateTypeLocalStorage = {
  name: string;
  title?: string;
  value: string[] | string | Record<any, any>;
  image?: string[];
};

type ActiveType = {
  type: string;
  name: string;
  value: string[] | string | Record<any, any>;
  image?: string;
};

export const initialState: StateTypeLocalStorage[] = [
  {
    name: actionTypeOfMedicalHistory.PERSONAL_INFORMATION,
    title: '',
    value: [],
  },
  {
    name: actionTypeOfMedicalHistory.CONTACT_INFORMATION,
    title: '',
    value: [],
  },
  {
    name: actionTypeOfMedicalHistory.PRIMARY_CARE_PHYSICIAN,
    title: '',
    value: {},
  },
  {
    name: actionTypeOfMedicalHistory.PHARMACY_INFORMATION,
    title: '',
    value: '',
  },
  {
    name: actionTypeOfMedicalHistory.INSURANCE_ID,
    title: '',
    value: [],
  },
  {
    name: actionTypeOfMedicalHistory.PHOTO_ID,
    title: '',
    value: [],
  },
  {
    name: actionTypeOfMedicalHistory.PERSONAL_INJURY,
    title: '',
    value: [],
  },
  {
    name: actionTypeOfMedicalHistory.CREDIT_CARD,
    title: '',
    value: '',
  },
  {
    name: actionTypeOfMedicalHistory.MEDICAL_HISTORY,
    title: '',
    value: [],
  },
  {
    name: actionTypeOfMedicalHistory.SURGICAL_HISTORY,
    title: '',
    value: [],
  },
  {
    name: actionTypeOfMedicalHistory.MEDICATIONS,
    title: '',
    value: [],
  },
  {
    name: actionTypeOfMedicalHistory.ALLERGIES,
    title: '',
    value: [],
  },
  {
    name: actionTypeOfMedicalHistory.SOCIAL_HISTORY,
    title: '',
    value: [],
  },
  {
    name: actionTypeOfMedicalHistory.FAMILY_HISTORY,
    title: '',
    value: [],
  },
  {
    name: actionTypeOfMedicalHistory.RELEVANT_MEDICAL_RECORDS,
    title: '',
    value: [],
  },
  {
    name: actionTypeOfMedicalHistory.ANY_RECENT_ISSUES,
    title: '',
    value: [],
  },
  {
    name: actionTypeOfMedicalHistory.ANY_RECENT_ISSUES_PAGES,
    title: '',
    value: [],
  },
];

const reducer = (state: any, action: ActiveType) => {
  switch (action.type) {
    default:
      return state.map((data: StateTypeLocalStorage) => {
        if (data.name === action.type) {
          return {
            ...data,
            title: action.name,
            value: action.value,
          };
        } return data;
      });
  }
};

export const usePersistMHReducer = () => {
  const [savedState, saveState] = useLocalStorage(
    LOCAL_STORAGE_MH_KEY,
    initialState,
  );

  const reducerLocalStorage = useCallback(
    (state: StateTypeLocalStorage[], action: ActiveType) => {
      const newState = reducer(state, action);
      saveState(newState);

      return newState;
    },
    [saveState],
  );

  return useReducer(reducerLocalStorage, savedState);
};

export const useClearLocalStorage = () => useLocalStorage(LOCAL_STORAGE_MH_KEY);
